import React from 'react';
import ComingSoon from 'components/ComingSoon';

export const SavedFolders = () => (
  <ComingSoon text="Save your favorites on TransparenTerra by organizing them into folders for easy access and management. Create your folders and lists, and share them with friends and colleagues." />
);
